import { render, staticRenderFns } from "./TaskTable.vue?vue&type=template&id=532c7a09&scoped=true&"
import script from "./TaskTable.vue?vue&type=script&lang=ts&"
export * from "./TaskTable.vue?vue&type=script&lang=ts&"
import style0 from "./TaskTable.vue?vue&type=style&index=0&id=532c7a09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532c7a09",
  null
  
)

export default component.exports